/**
 * @prop --vx-mega-menu-column-gap: The gap between columns in the mega menu. Defaults to 48px.
 * @prop --vx-mega-menu-hover-color: The color of the mega menu items on hover. Defaults to the navbar item hover color or the Material Design accent color.
 * @prop --vx-mega-menu-title-color: The color of the mega menu titles. Defaults to the navbar title color or the Material Design accent color.
 * @prop --vx-mega-menu-background: The background color of the mega menu. Defaults to the navbar background color or white.
 * @prop --vx-mega-menu--font-size: The font size of the mega menu bar. Defaults to 16px.
 * @prop --animation-duration: The duration of the animation in the mega menu. Defaults to 0.1s.
 * @prop --vx-mega-menu-height-animation-duration: The duration of the animation of the menu height. Defaults to 0.1s.
 * @prop --vx-mega-menu-flyout-box-shadow: The box shadow of the mega menu flyout. Defaults to a 12px by 12px shadow with a 0.3215686275 opacity.
 * @prop --vx-mega-menu-flyout-height: The height of the flyout container.
 */
:host {
  user-select: none;
  box-sizing: border-box;
  text-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
}

@keyframes menu-animation {
  0% {
    box-shadow: none;
    height: 0;
    opacity: 0;
  }
  100% {
    box-shadow: var(--vx-mega-menu-flyout-box-shadow, 0 12px 12px rgba(0, 0, 0, 0.322));
    height: var(--vx-mega-menu-flyout-height, 270px);
    opacity: 1;
  }
}
nav {
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: var(--vx-mega-menu--font-size, 16px);
}

.item-wrapper {
  display: inline-flex;
}
.item-wrapper > img {
  width: 100%;
  height: auto;
}

a {
  text-decoration: none;
  color: currentcolor;
  transition: color var(--animation-duration, var(--transition-duration, 0.1s));
  line-height: 24px;
}

.menu-item {
  font-size: var(--vx-mega-menu--font-size, 16px);
}
.menu-item .sub-menu {
  display: none;
  width: 100%;
  gap: var(--vx-mega-menu-column-gap, 48px);
}
.menu-item .title {
  color: var(--vx-mega-menu-title-color, var(--navbar-title-color, var(--mdc-theme-accent)));
}
.menu-item.level-0 {
  padding: 16px 14px;
  font-size: 1.125em;
}
.menu-item.level-0 > .sub-menu {
  display: flex;
  background: var(--vx-mega-menu-background, var(--nav-background, #fff));
  position: absolute;
  left: 0;
  top: calc(100% - 8px);
  overflow: hidden;
  height: 0;
}
.menu-item.level-0.has-children {
  margin-right: 26px;
}
.menu-item.level-0.has-children > a::after {
  transform: rotate(90deg);
  font-family: "Material Icons", serif;
  display: inline;
  position: absolute;
  content: "\e5cc";
  height: 24px;
  width: 24px;
  font-size: 1.6em;
  margin-top: -2px;
  margin-left: 4px;
}
.menu-item.level-0:hover > .underline, .menu-item.level-0.active > .underline {
  width: 100%;
}
.menu-item.level-0:hover.has-children > .underline, .menu-item.level-0.active.has-children > .underline {
  width: calc(100% + 24px);
}
.menu-item.level-0:focus-within.animate > .sub-menu, .menu-item.level-0:hover.animate > .sub-menu {
  animation: menu-animation var(--vx-mega-menu-height-animation-duration, 0.1s) ease-in forwards;
  animation-delay: var(--animation-delay, 0.2s);
}
.menu-item.level-0:focus-within:not(.animate) > .sub-menu, .menu-item.level-0:hover:not(.animate) > .sub-menu {
  animation: none;
  height: var(--vx-mega-menu-flyout-height, 270px);
  opacity: 1;
  box-shadow: var(--vx-mega-menu-flyout-box-shadow, 0 12px 12px rgba(0, 0, 0, 0.322));
}
.menu-item.level-1 a, .menu-item.level-1 .title {
  padding: 8px 16px;
  line-height: unset;
}
.menu-item.level-1 .title {
  padding: 24px 16px;
  font-size: 18px;
}
.menu-item.level-1 .sub-menu {
  display: flex;
  gap: 8px;
  width: 100%;
  flex-direction: column;
}
.menu-item > .underline {
  margin-top: 6px;
  width: 0;
  height: 2px;
  background: currentcolor;
}
.menu-item:hover:not(.level-0) > a, .menu-item.active:not(.level-0) > a {
  color: var(--vx-mega-menu-hover-color, var(--navbar--item-color-hover, var(--mdc-theme-accent)));
}